import {
  SET_SELECTED_FUND_TICKERS,
  SET_SELECTED_CHARS,
  SET_SELECTED_SECTOR,
  SET_SELECTED_COUNTRY,
  RESET_SCROLL_COUNTRY,
  SET_TA_FUND_TICKERS,
  SET_ACTIVE_PANE,
  REMOVE_TICKER,
  CLEAR_TICKERS,
  CLEAR_INITIAL_TICKERS,
  SELECTED_RELATED,
  SET_PERF_START_DATE,
  SET_PERF_END_DATE,
  SET_FULLEXCEL_STATUS,
  SET_CURRENTEXCEL_STATUS,
  SET_CURRENT_URL,
  SET_GROWTH_METRIC_QUALITY,
  SET_ALL_GROWTH_CHARS,
  SET_SELECT_ADDITIONALPI,
  SET_SELECTED_RISK,
  SET_ACTIVE_SOE_PANE,
  SET_ACTIVE_SOE_DATA_TYPE,
  TOGGLE_SHOW_FUND_SELECTION,
  ADD_SCREENED_FUND,
  SET_SCREENED_FUNDS,
  SET_DRAW_DOWN_PERIOD,
  UPDATE_SEARCH_TICKER,
  REMOVE_SCREENED_FUND,
  APPEND_SEARCH_TICKER,
  REMOVE_SEARCH_TICKER,
} from '../actions';


// params reducer
const params = (state, action) => {
  if (state === undefined) {
    return {}
  }
  switch (action.type) {
    case SET_SELECTED_FUND_TICKERS:
      const fund = action.payload
      let clonedObjArray = [...state.selectedFunds]
      let index = clonedObjArray.findIndex(x => x.ticker === fund.ticker)
      if (index === -1) {
        clonedObjArray.push(action.payload)
      } else {
        clonedObjArray.splice(index, 1)
      }
      return Object.assign({}, state, {
        selectedFunds: clonedObjArray,
        fcBottomSelected: 'show'
      })
    case SET_TA_FUND_TICKERS:
      const selected = [...state.selectedFunds]
      const selectedUp = selected.concat(action.payload)
      return Object.assign({}, state, {
        selectedFunds: selectedUp
      })
    case REMOVE_TICKER:
      const selectedF = [...state.selectedFunds]
      const selectedFUp = selectedF.filter(x => x.externalID !== action.payload)
      return Object.assign({}, state, {
        selectedFunds: selectedFUp
      })
    case CLEAR_TICKERS:
      if (state.selectedFunds.length > 0) {
        return Object.assign({}, state, {
          selectedFunds: [],
          tickerSearch: [],
          perfStartDate: null,
          perfEndDate: null,
          showFundSelection: true,
          screenedFunds: []
        })
      } else {
        return Object.assign({}, state, {
          selectedFunds: [],
          tickerSearch: [],
          showFundSelection: true,
          screenedFunds: []
        })
      }
    case SET_ACTIVE_PANE:
      return Object.assign({}, state, {
        activePane: action.payload
      })
    case SET_SELECTED_CHARS:
      const char = action.payload
      let clonedCharArray = [...state.selectedChars]
      let charIndex = clonedCharArray.findIndex(x => x === char)
      if (charIndex === -1) {
        clonedCharArray.push(action.payload)
      } else {
        clonedCharArray.splice(charIndex, 1)
      }
      return Object.assign({}, state, {
        selectedChars: clonedCharArray
      })

    case SET_SELECTED_RISK:
      const risk = action.payload
      return Object.assign({}, state, {
        selectedRisk: risk
      })
    case SET_SELECTED_SECTOR:
      const sector = action.payload.name
      let newSector = ''
      if (sector !== state.selectedSector) {
        newSector = sector
      }
      return Object.assign({}, state, {
        selectedSector: newSector
      })
    case SET_SELECTED_COUNTRY:
      const country = action.payload.name
      let newCountry = ''
      if (country !== state.selectedCountry) {
        newCountry = country
      }
      return Object.assign({}, state, {
        selectedCountry: newCountry,
        scrollCountry: true
      })
    case RESET_SCROLL_COUNTRY:
      return Object.assign({}, state, {
        scrollCountry: false
      })
    case CLEAR_INITIAL_TICKERS:
      return Object.assign({}, state, {
        initialTickers: []
      })
    case SELECTED_RELATED:
      return Object.assign({}, state, {
        selectedRelated: action.payload
      })
    case SET_PERF_START_DATE:
      return Object.assign({}, state, {
        perfStartDate: action.payload
      })
    case SET_PERF_END_DATE:
      return Object.assign({}, state, {
        perfEndDate: action.payload
      })
    case SET_FULLEXCEL_STATUS:
      return Object.assign({}, state, {
        fullExcelStatus: action.value
      })
    case SET_CURRENTEXCEL_STATUS:
      return Object.assign({}, state, {
        currentExcelStatus: action.value
      })
    case SET_CURRENT_URL:
      const currentURL = action.value
      return Object.assign({}, state, {
        currentURL: currentURL
      })
    case SET_GROWTH_METRIC_QUALITY:
      return Object.assign({}, state, {
        growthMetricQuality: action.payload
      })
    //SET_ALL_GROWTH_CHARS
    case SET_ALL_GROWTH_CHARS:
      return Object.assign({}, state, {
        growthMetricQtyHistoricFlag: action.payload
      })
    case SET_SELECT_ADDITIONALPI:
      return Object.assign({}, state, {
        seeAdditionalPIFlag: action.payload
      })
    case SET_ACTIVE_SOE_PANE:
      return Object.assign({}, state, {
        activeSoePane: action.payload
      })
    case SET_ACTIVE_SOE_DATA_TYPE:
      return Object.assign({}, state, {
        activeSoeDataType: action.payload.value
      })
    case TOGGLE_SHOW_FUND_SELECTION:
      return Object.assign({}, state, {
        showFundSelection: !state.showFundSelection
      })
    case ADD_SCREENED_FUND:
      let tempScreenedFunds = [...state.screenedFunds];
      let indexScreened = tempScreenedFunds.findIndex((x) => x.externalID === action.payload.externalID);
      if (indexScreened === -1) {
          // Add the new fields to the payload object
          const newFund = {
              ...action.payload,
          };
          tempScreenedFunds.push(newFund);
      }
      // Update the tickerSearch array with the new format and mapping
      let newTickerSearch = tempScreenedFunds.map((fund) => {
        return {
            label: fund.name + " (" + fund.ticker + ")",
            name: fund.name,
            ticker: fund.ticker,
            value: fund.externalID,
        };
       });      
      const newState = Object.assign({}, state, {
          screenedFunds: tempScreenedFunds,
          tickerSearch: newTickerSearch,
      });
      return newState;
    case REMOVE_SCREENED_FUND:
        return {
            ...state,
            screenedFunds: state.screenedFunds.filter(fund => fund.externalID !== action.payload)
        };
    case UPDATE_SEARCH_TICKER:
        return {
            ...state,
            tickerSearch: action.payload,
        }; 
    case APPEND_SEARCH_TICKER:
        return {
            ...state,
            tickerSearch: [...state.tickerSearch, action.payload],
        };    
    case REMOVE_SEARCH_TICKER:
        const updatedTickerSearch = state.tickerSearch.filter((fund) => {
            const values = Object.values(fund);
            return !values.some((value) => value === action.payload);
        });
        return {
            ...state,
            tickerSearch: updatedTickerSearch,
        };
    case SET_DRAW_DOWN_PERIOD:
      return Object.assign({}, state, {
        drawdownNumber: action.payload
      })
    case SET_SCREENED_FUNDS:
      return {
        ...state,
        screenedFunds: action.payload || []
      };
      
    default:
      return state
  }
}
export default params
